import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Navigate, Outlet } from "react-router-dom";
import { isLogin } from "../../infrastructure/utils/index";
import routes from "./routes";

function PrivateRoute() {
  if (isLogin()) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}>
        <Outlet />
      </GoogleReCaptchaProvider>
    );
  }

  return <Navigate to={routes.LOGIN} />;
}

export default PrivateRoute;
